export const GOUSTO_VALUE = {
  heading: 'Reasons why Gousto boxes are worth it',
  altText:
    'Customer holds recipe cards above pre-portioned ingredients inside an insulated Gousto box.',
  ctaText: 'Unlock 50% off now',
  benefits: [
    {
      title: 'Convenience',
      description: 'Ingredients delivered right to your door.',
    },
    {
      title: 'No waste ',
      description: 'Say goodbye to food waste and half-used jars.',
    },
    {
      title: 'Time-saving ',
      description: 'Plan your weekly meals in minutes, not hours.',
    },
    {
      title: 'Flexible subscription ',
      description: 'No commitments. No cancellation fees. Tailor Gousto to your lifestyle.',
    },
  ],
}
